export enum SpaceRenovationRequestStatus {
  InProgress = 1,
  InHandling = 752560001,
  Approved = 752560002,

  Completed = 752560003,

  Canceled = 6,
  Rejected = 752560004,
}

export enum RenovationExecutor {
  Organization = 752560000,
  Person = 752560001,
  PortalUser = 752560002,
  ForeignCompany = 752560003,
}
